import {
  Card,
  CardContent,
  CardMedia,
  Divider,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import { Box, Grid, Stack } from "@mui/system";
import VerticalLinearStepper from "../VerticalLinearStepper";

export const LEDWorkshop = () => {
  const blocks = [
    {
      label: "ESP32 Gereedmaken",
      image: "esp32.jpg",
      sub: "Het brein",
    },
    {
      label: "WLED Installeren",
      image: "wled.png",
      sub: "De software",
    },
    {
      label: "LEDstrip aansluiten",
      image: "strip.jpg",
      sub: "Licht-hardware",
    },
    {
      label: "Play!",
      image: "color.jpg",
      sub: "🪩",
    },
  ];

  return (
    <VerticalLinearStepper
      steps={[
        {
          label: "👋 Welkom!",
          description: ``,
          content: (
            <>
              <Box
                component="video"
                src="presentation-data/LED/led5.mp4"
                autoPlay
                loop
                muted
                sx={{
                  width: "100%",
                  borderRadius: 2,
                  boxShadow: 3,
                }}
              />
            </>
          ),
        },
        {
          label: "🤔 Wat gaan we doen? ",
          description: ``,
          content: (
            <Stack gap={5}>
              <Grid container spacing={2}>
                {blocks.map((x) => (
                  <Grid size={3}>
                    <Card color="primary">
                      <CardContent>
                        <Typography variant="h5">{x.label}</Typography>
                      </CardContent>
                      <CardMedia
                        component="img"
                        height="194"
                        image={`/presentation-data/LED/${x.image}`}
                      />
                      <CardContent>{x.sub}</CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>

              <Box>
                <Typography variant="h4">Wat kun je ermee?</Typography>
                <Typography variant="body1">
                  Aan het einde van deze workshop kun je een LEDstrip aansturen
                  met allerlei toffe lichteffecten via gebruiksvriendelijke
                  software
                </Typography>
              </Box>
            </Stack>
          ),
        },
        {
          label: " 💡 Wat is LED?",
          description: `Een LED is een klein, zuinig lampje dat licht maakt wanneer er stroom doorheen loopt.`,
          content: (
            <Stack>
              <Grid container spacing={5}>
                <Grid size={4}>
                  <Card color="primary">
                    <CardContent>
                      <Typography variant="h5">Closeup</Typography>
                    </CardContent>
                    <CardMedia
                      component="img"
                      // height="194"
                      image={`/presentation-data/LED/led-closeup.webp`}
                    />
                  </Card>
                </Grid>
                <Grid size={8}>
                  <List>
                    <ListItem>
                      <Typography variant="body1">
                        👉 LED staat voor Light Emitting Diode
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Een simpel klein elektrisch lampje
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Zet stroom direct om in licht, en wordt niet heet
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Gebruik in auto's, displays, podia, festivals etc.
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        👉 RGB Kleurmengen maakt miljoenen kleuren mogelijk
                      </Typography>
                    </ListItem>
                    <List sx={{ pl: 5 }}>
                      <ListItem>✔ 0-255</ListItem>
                      <ListItem>✔ Eén pixel bestaat uit RG en B</ListItem>
                    </List>
                  </List>
                </Grid>
              </Grid>
            </Stack>
          ),
        },
        {
          label: " 👾 ESP32",
          description: `Een ESP32 is een kleine computer die hardware aanstuurt en tegelijk met het netwerk kan praten.`,
          content: (
            <Stack>
              <Grid container spacing={5}>
                <Grid size={4}>
                  <Card color="primary">
                    <CardContent>
                      <Typography variant="h5"></Typography>
                    </CardContent>
                    <CardMedia
                      component="img"
                      // height="194"
                      image={`/presentation-data/LED/esp32.jpg`}
                    />
                  </Card>
                </Grid>
                <Grid size={8}>
                  <List>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Microcomputer / microcontroller op één chip
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Berekeningen maken
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">👉 Signalen lezen</Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Dingen aansturen, zoals LEDs
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Klein en goedkoop
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Gebruik in smart lighting, domotica, escaperooms etc
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">👉 GPIO pinnen</Typography>
                    </ListItem>
                    <List sx={{ pl: 5 }}>
                      <ListItem>✔ data versturen</ListItem>
                      <ListItem>✔ data ontvangen</ListItem>
                      <ListItem>✔ in of uitschakelen</ListItem>
                    </List>
                  </List>
                </Grid>
              </Grid>
            </Stack>
          ),
        },
        {
          label: "🎨 WLED",
          description: `WLED maakt van een rij lampjes een slim, netwerkgestuurd lichtsysteem.`,
          content: (
            <Stack>
              <Grid container spacing={5}>
                <Grid size={4}>
                  <Card color="primary">
                    <CardContent>
                      <Typography variant="h5"></Typography>
                    </CardContent>
                    <CardMedia
                      component="img"
                      image={`/presentation-data/LED/wled.png`}
                    />
                  </Card>
                </Grid>
                <Grid size={8}>
                  <List>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Open Source Software voor aansturen van
                        LED-verlichting
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Speciaal gemaakt voor adresseerbare LED strips
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Je bedient WLED via een webpagina
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Geen app / account nodig
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Beginner: klikken en spelen
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Gevorderd: presets, segmenten
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Expert: JSON, automatisering, integraties, lichtshows
                      </Typography>
                    </ListItem>
                  </List>
                </Grid>
              </Grid>
            </Stack>
          ),
        },
        {
          label: " ⌇ Ledstrips",
          description: `Een LED-strip is een rij LED’s op een flexibele printplaat`,
          content: (
            <Stack>
              <Grid container spacing={5}>
                <Grid size={4}>
                  <Card color="primary">
                    <CardContent>
                      <Typography variant="h5"></Typography>
                    </CardContent>
                    <CardMedia
                      component="img"
                      image={`/presentation-data/LED/strip.jpg`}
                    />
                  </Card>
                </Grid>
                <Grid size={8}>
                  <List>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Adresseerbare LEDs
                      </Typography>
                    </ListItem>
                    <List sx={{ pl: 5 }}>
                      <ListItem>✔ Iedere LED is apart aan te sturen</ListItem>
                    </List>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Niet addresseerbare LEDs
                      </Typography>
                    </ListItem>
                    <List sx={{ pl: 5 }}>
                      <ListItem>✔ Alle leds doen hetzelfde</ListItem>
                    </List>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Werkt op 5v, 12v of 24v
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        👉 Aansluiting: stroom, grond en data.
                      </Typography>
                    </ListItem>
                  </List>
                </Grid>
              </Grid>
            </Stack>
          ),
        },
        {
          label: "🚀 WLED Installeren",
          description: ``,
          content: (
            <Stack>
              <Grid container spacing={5}>
                <Grid size={4}>
                  <Card color="primary">
                    <CardContent>
                      <Typography variant="h5"></Typography>
                    </CardContent>
                    <CardMedia
                      component="img"
                      image={`/presentation-data/LED/wled.png`}
                    />
                    <Divider sx={{ my: 5 }} />
                    <CardMedia
                      component="img"
                      image={`/presentation-data/LED/visit-device.jpg`}
                    />
                  </Card>
                </Grid>
                <Grid size={8}>
                  <List>
                    <ListItem>
                      <Typography variant="body1">
                        1️⃣ Log in op je Mac met <br />
                        workshop <br />
                        #1Geheim
                      </Typography>
                    </ListItem>
                  </List>
                  <List>
                    <ListItem>
                      <Typography variant="body1">
                        2️⃣ Open Google Chrome
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        3️⃣ Navigeer naar https://install.wled.me/
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        4️⃣ Plug je ESP32 in aan de zijkant van je toetsenbord
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        5️⃣ Volg de stappen en installeer WLED
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        6️⃣ Wi-Fi nodig? De docent zet access points klaar om op
                        in te kunnen loggen. Verbindt zowel WLED als je computer
                        met dit access point.
                      </Typography>
                    </ListItem>
                  </List>
                </Grid>
              </Grid>
            </Stack>
          ),
        },
        {
          label: "🧑‍🔧 LEDstrip aansluiten",
          description: ``,
          content: (
            <Stack>
              <img src="presentation-data/LED/connections.png" alt="" />
            </Stack>
          ),
        },
      ]}
    />
  );
};
